import { msg } from '@lingui/core/macro';
import { defineFilters } from '@/shared/filters/define-filters';

/** `availableFilters` das Regras Dinâmicas (DynamicRulesListContainer.tsx:91-100): Todos e Nome. */
export const dynamicRulesFilters = defineFilters([
  { key: 'searchString', type: 'search', label: msg`Todos`, placeholder: msg`Buscar regras dinâmicas` },
  { key: 'name', type: 'text', label: msg`Nome` },
]);
